import { RouteConfig } from 'vue-router'

const Form = () => import('../views/after-school-tranning/Form.vue')

export const formRoute: RouteConfig = {
  path: '/after-school-tranning-form',
  name: 'after_school_tranning_form',
  component: Form,
  props: (route) => ({ ...route.query, ...route.params }),
  children: [
    {
      path: 'step1',
      name: 'after_school_tranning_form_step1',
      component: () => import('../views/after-school-tranning/Step1.vue'),
      meta: {
        title: '布置任务（1/2）',
      },
    },
    {
      path: 'step2',
      name: 'after_school_tranning_form_step2',
      component: () => import('../views/after-school-tranning/Step2.vue'),
      meta: {
        title: '布置任务（2/2）',
      },
    },
    {
      path: 'select-dirlls',
      name: 'after_school_tranning_form_select_drills',
      component: () => import('../views/after-school-tranning/DrillSelector.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '选择项目',
      },
    },
    {
      path: 'drill-detail',
      name: 'after_school_tranning_form_drill_detail',
      component: () => import('../views/homework/HomeworkDrillDetail.vue'),
      props: (router) => ({
        drillId: router.query.id,
      }),
      meta: {
        title: '项目详情',
      },
    },
  ],
}

export default [formRoute]
